import {
  GSTConnectionModal,
  useGstConnection,
  buildSupportMessage,
} from "../../../../components/GSTConnection";
import type { LendingJobType } from "../../../../interfaces/interfaces";

interface LendingConnectGstProps {
  onClose: (draft?: { gstin: string; username: string }) => void;
  onConnected: (result: { gstin: string; username: string; jobId: string | null; statementJobId: string | null }) => void;
  initialGstin?: string;
  initialUsername?: string;
  formDetails: {
    gstin: string;
    username: string;
    statementJobId: string;
    formType: LendingJobType;
    formId: number;
    monthYear: string;
    fieldName: string;
  };
}

export default function LendingConnectGst({
  onClose,
  onConnected,
  initialGstin,
  initialUsername,
  formDetails,
}: LendingConnectGstProps) {
  const conn = useGstConnection({
    initialGstin: initialGstin ?? formDetails.gstin,
    initialUsername: initialUsername ?? formDetails.username,
    supportMessage: buildSupportMessage(
      "I'm facing issue while connecting the GSTIN."
    ),
    onConnected: (result) =>
      onConnected({
        gstin: result.gstin,
        username: result.username,
        jobId: result.fetchJobId,
        statementJobId: result.fetchJobId,
      }),
    mapOtpError: (message) => {
      if (message === "API Access/GSTIN Username Error")
        return "API Access/GSTIN Username Error";
      if (message === "GSTIN OTP Expired") return "GSTIN OTP Expired";
      return message ?? "Technical Error. Please try again.";
    },
  });

  return (
    <GSTConnectionModal
      conn={conn}
      onClose={() => onClose({ gstin: conn.gstin, username: conn.gstUsername })}
    />
  );
}
